<script>
import FavouriteButton from './FavouriteButton.vue';
import CartComponent from './CartComponent.vue';
import LattlastButton from './LattlastButton.vue';
import LangButton from './LangButton.vue';
import ColorMode from './ColorMode.vue';

export default {
  components: {
    FavouriteButton,
    CartComponent,
    LattlastButton,
    LangButton,
    ColorMode,
  },
  props: [
    'language',
    'cartUrl',
    'fOpentext',
    'fLinktext',
    'favoriteActive',
    'langActive',
    'quicklinks',
    'lattlast',
  ],
  computed: {
    colorThemeAvailable() {
      if (typeof window !== 'undefined') {
        return document.documentElement.classList.contains('main-site-only');
      }
      return false;
    },
  },
  methods: {
    showFavBox() {
      this.$emit('show-fav-box');
    },
    showLangBox() {
      this.$emit('show-lang-box');
    },
    forwardEmit(colorTheme) {
      this.$emit('color-theme-changed', colorTheme);
    },
  },
};
</script>

<template>
  <div class="container miun-favourites">
    <div class="row">
      <div class="col">
        <nav id="fav-navigation">
          <div class="miun-favourites__quicklinks-wrap">
            <ul class="list-unstyled mb-0 miun-favourites__quicklinks left">
              <li v-for="quicklink in quicklinks" class="favourite-button">
                <a :class="quicklink.linkCustomClass" :href="quicklink.url">{{
                  quicklink.title
                }}</a>
              </li>
            </ul>
            <div class="miun-fade"></div>
          </div>
          <ul class="list-unstyled mb-0 miun-favourites__links right">
            <FavouriteButton
              :favoriteActive="favoriteActive"
              @show-fav-box="showFavBox"
              :fOpentext="fOpentext"
              :fLinktext="fLinktext" />
            <CartComponent :cartUrl="cartUrl" />
            <LattlastButton :lattlast="lattlast" />
            <LangButton
              :language="language"
              :langActive="langActive"
              @show-lang-box="showLangBox" />
            <li v-if="colorThemeAvailable">
              <ColorMode @color-theme-changed="forwardEmit" />
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
